import api from '@edu-fe/api'

wx.error(res => {
  // 无限次执行
  // InitShare._init()
})
const InitShare = {

  async _init () {
    const res = await api.payment.getWxConfig(window.localStorage.getItem('wkAppId'), encodeURIComponent(this.serialize()))
    await this._initWx(res.data)
  },

  async _initWx (configs) {
    let jsonData = configs
    jsonData['jsApiList'] = ['chooseWXPay', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'getLocalImgData', 'chooseImage']
    return new Promise(resolve => {
      wx.config({ ...jsonData })
      resolve()
      // wx.ready(() => resolve())
    })
  },
  serialize () {
    return window.location.href.split('#')[0]
  }
}

export default InitShare
